// extracted by mini-css-extract-plugin
export default {"cls1":"SubmittedErrorDetails-Button_cls1__myavP","cls2":"SubmittedErrorDetails-Button_cls2__aO-6I SubmittedErrorDetails-Button_cls1__myavP"};